import axios from './axios'

export function login(sub) {
  return axios({
    method: "post",
    url: '/api/v1/token/',
    data: sub
  })
}

export function logout(sub) {
  return axios({
    method: "post",
    url: '/api/v1/token/logout/',
    data: sub
  })
}